// src/components/BetaApprovePanel.js — extracted from App.js
import React, { useState } from "react";
import { supabase } from "../lib/supabase";
import { thcEmailHtml, capabilitiesHtml } from "../lib/utils";

// ─── Beta Approve Panel ───────────────────────────────────────────────────────
export function BetaApprovePanel({ r, betaRequests, saveBetaReqs, toast }) {
  const [note, setNote]     = useState("");
  const [saving, setSaving] = useState(false);

  const genCode = () => {
    const seg = () => Math.random().toString(36).slice(2,6).toUpperCase();
    return `THC-${seg()}-${seg()}`;
  };

  const approve = async () => {
    setSaving(true);
    const code = genCode();
    const updated = { ...r, status:"approved", beta_code:code, admin_note:note||null, approved_at:new Date().toISOString() };
    saveBetaReqs(betaRequests.map(x=>x.id!==r.id?x:updated));
    // Persist directly to Supabase (saveBetaReqs uses upsert which handles this)
    // Send email with code
    try {
      await supabase.functions.invoke("send-email", { body: {
        to: r.email,
        subject: "Your THC.watch Beta Access Code",
        html: thcEmailHtml({ title:"Your beta access code.", subtitle:`Hi ${r.name} — you've been approved for early access to THC.watch.`, codeBlock:code, bodyHtml:`Enter this code at <a href="https://thc.watch" style="color:#0C0C10">thc.watch</a> to unlock the platform.`, footerNote:"This code is single-use and personal to you. Valid until used." })
      }});
    } catch {}
    toast(`Approved — code ${code} emailed to ${r.email}`);
    setSaving(false);
  };

  const reject = () => {
    saveBetaReqs(betaRequests.map(x=>x.id!==r.id?x:{...x,status:"rejected",admin_note:note||null}));
    toast("Request rejected.");
  };

  return (
    <div style={{display:"flex",gap:8,flexWrap:"wrap",borderTop:"1px solid var(--bd)",paddingTop:10}}>
      <input value={note} onChange={e=>setNote(e.target.value)} placeholder="Note (optional)" style={{flex:1,minWidth:140,fontSize:12}}/>
      <button className="btn-green" style={{padding:"7px 14px",fontSize:12}} onClick={approve} disabled={saving}>
        {saving?"Sending…":"Approve & Email Code ✓"}
      </button>
      <button className="btn-ghost" style={{padding:"7px 14px",fontSize:12,color:"var(--red)",borderColor:"var(--rbd)"}} onClick={reject}>Reject</button>
    </div>
  );
}

// ─── Client-side image compression ───────────────────────────────────────────
